import { render, staticRenderFns } from "./TfacSummaryPage.vue?vue&type=template&id=0683e8ba&scoped=true"
import script from "./TfacSummaryPage.vue?vue&type=script&lang=js"
export * from "./TfacSummaryPage.vue?vue&type=script&lang=js"
import style0 from "./TfacSummaryPage.vue?vue&type=style&index=0&id=0683e8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683e8ba",
  null
  
)

export default component.exports